import { CreateAlertConfigurationInput, DeviceAlertComparisonType, DeviceAlertMetricName, MetricField, MetricUnit, UpdateAlertNotificationConfigurationInput } from "@/__generated__/graphql";
import { AlertConfigurationForm } from "../../alertsConfigurationV2/schemas/alertConfigurationSchema";

const getMetricUnit = (metric: MetricField): MetricUnit => {
  switch (metric) {
    case MetricField.Flow:
      return MetricUnit.LiterPerSecond;
    case MetricField.Level:
      return MetricUnit.Meter;
    case MetricField.BatterySoc:
      return MetricUnit.Percent;
    case MetricField.Temperature:
      return MetricUnit.Celsius;
    case MetricField.Conductivity:
      return MetricUnit.MicrosiemensPerCentimeter;
    case MetricField.Orp:
      return MetricUnit.Volt;
    case MetricField.DissolvedOxygen:
      return MetricUnit.MilligramPerLiter;
    case MetricField.Ph:
      return MetricUnit.Ph;
    case MetricField.DissolvedOxygenSaturation:
      return MetricUnit.Percent;
    case MetricField.TurbidityFnu:
      return MetricUnit.Fnu;
    case MetricField.TurbidityNtu:
      return MetricUnit.Ntu;
    case MetricField.Velocity:
      return MetricUnit.CentimeterPerSecond;
    default:
      return MetricUnit.None;
  }
};

const getComparisonType = (
  criteria: 'range' | 'threshold',
  modality: string
): DeviceAlertComparisonType => {
  if (criteria === 'range') {
    return modality === 'in_range'
      ? DeviceAlertComparisonType.InsideRange
      : DeviceAlertComparisonType.OutsideRange;
  } else {
    return modality === 'above'
      ? DeviceAlertComparisonType.Above
      : DeviceAlertComparisonType.Below;
  }
};

export const transformFormInputToCreateAlertConfigurationInput =  (
  data: AlertConfigurationForm
): CreateAlertConfigurationInput => {

  const typeConfigurations = data.configurations.map(config => {
    if (config.criteria === 'threshold') {
      return {
        threshold: {
          type: config.alertType,
          comparisonType: getComparisonType(config.criteria, config.modality),
          threshold: config.threshold,
          notificationDelaySec: 28800,
        }
      };
    } else if (config.criteria === 'range') {
      return {
        range: {
          type: config.alertType,
          comparisonType: getComparisonType(config.criteria, config.modality),
          min: config.minimum,
          max: config.maximum,
          notificationDelaySec: 28800,
        }
      };
    }
    throw new Error('Invalid configuration criteria');
  })

  return {
    deviceId: data.deviceId,
    metric: data.metric as MetricField,
    unit: data.unit,
    typeConfigurations: typeConfigurations as CreateAlertConfigurationInput['typeConfigurations'],
    usersToNotify: data.usersToNotify.map(user => ({ ...user, userId: Number(user.userId) })),
  }
}

export const transformFormInputToAlertNotificationConfigurationInput = (
  data: AlertConfigurationForm
): UpdateAlertNotificationConfigurationInput[] => {
  
  return data.usersToNotify.map(user => {
    return {
      userId: Number(user.userId),
      deviceId: data.deviceId,
      notifyEmail: user.useEmail,
      notifySms: user.useSms,
      notifyPush: user.useAmaruLite,
      notifyWhatsapp: user.useWhatsapp
    }
  })
}